import { registerComponent } from '@gig/magic-common';
import TabItemComponent from './tab-item.vue.js';

var TabItem = registerComponent(TabItemComponent);

export { TabItem };
